import React from 'react'
import { CSSInterpolation } from '@emotion/serialize'
import { css, styled, Theme } from '@mui/material/styles'
import { Link, LinkProps, NavLinkProps } from 'react-router-dom'

type StyledLinkVariant = (theme: Theme, underline?: boolean, bold?: boolean, disabled?: boolean) => CSSInterpolation

const primary: StyledLinkVariant = (theme: Theme, underline?: boolean, bold?: boolean, disabled?: boolean) => ({
  color: disabled ? theme.palette.custom.light2.grey : theme.palette.custom.blue,
  textDecoration: 'none',
  background: underline ? `linear-gradient(${theme.palette.custom.blue} 0 0)` : '',
  backgroundSize: '100% 1px',
  backgroundPosition: 'left bottom',
  backgroundRepeat: 'no-repeat',
  transition: 'background-size 200ms',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: bold ? 'bold' : '',

  '&:hover': {
    color: theme.palette.text.dark.primary,
    backgroundSize: '0 1px',
    cursor: 'pointer',
  },
  '&:visited':{
    color:theme.palette.custom.purple
  },
  '&:visited:hover':{
    color:theme.palette.text.dark.primary,
  },
  '&:active':{
    color:theme.palette.text.dark.primary
  }
})

const wrapper: StyledLinkVariant = () => `
  font-size: 0;
}`

const anchorVariants = {
  primary,
  wrapper,
}

export interface AnchorProps extends LinkProps {
  children?: React.ReactNode
  external?: boolean
  to: NavLinkProps['to']
  underline?: boolean
  bold?: boolean
  disabled?: boolean
  $variant?: keyof typeof anchorVariants
}

export const anchorCss = ({
  theme,
  $variant = 'primary',
  underline = false,
  bold = false,
  disabled,
}: Pick<AnchorProps, '$variant'> & { theme: Theme, underline?: boolean, bold?: boolean, disabled?: boolean }) => css(anchorVariants[$variant](theme, underline, bold, disabled))

export const StyledAnchor = styled(
  ({ external, to, children, ...props }: AnchorProps) => {
    return external ? (
      <a href={`${to}`} {...props}>
        {children}
      </a>
    ) : (
      <Link to={to} {...props}>
        {children}
      </Link>
    )
  }, {
    name: 'StyledAnchor',
    shouldForwardProp: prop => prop !== 'underline'
  })(anchorCss)
